import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faExpand, faHandshake } from '@fortawesome/free-solid-svg-icons';
// Using your local userimg as a placeholder for the vertical rects
import userimg from '../components/img/img5.jpg';


import ana from "../components/img/mou/ana.jpg";
import center from "../components/img/mou/center.jpg";
import center2 from "../components/img/mou/center2.jpg";
import centralindia from "../components/img/mou/centralindia.jpg";
import Cleanearth from "../components/img/mou/cleanearth.jpg";
import dranil from "../components/img/mou/dranil.jpg";
import dranil2 from "../components/img/mou/dranil2.jpg";
import edu from "../components/img/mou/edu.jpg";
import genesis from "../components/img/mou/genesis.jpg";
import genesis2 from "../components/img/mou/genesis2.jpg";
import grand from "../components/img/mou/grand.jpg";
import ign from "../components/img/mou/IGN.jpg";
import impact from "../components/img/mou/impact.jpg";
import mafaza1 from "../components/img/mou/mafaza1.jpg";
import mafaza2 from "../components/img/mou/mafaza2.jpg";
import mafaza3 from "../components/img/mou/mafaza3.jpg";
import mafaza4 from "../components/img/mou/mafaza4.jpg";
import mafaza5 from "../components/img/mou/mafaza5.jpg";
import mafaza6 from "../components/img/mou/mafaza6.jpg";
import mafaza7 from "../components/img/mou/mafaza7.jpg";
import mafaza8 from "../components/img/mou/mafaza8.jpg";
import mafaza9 from "../components/img/mou/mafaza9.jpg";
import mafaza10 from "../components/img/mou/mafaza10.jpg";
import mafaza11 from "../components/img/mou/mafaza11.jpg";
import sarvakala from "../components/img/mou/sarvakala.jpg";
import sarvakala2 from "../components/img/mou/sarvakala2.jpg";
import sora from "../components/img/mou/sora.jpg";
import tradeventure from "../components/img/mou/tradeventure.jpg";
import tuli from "../components/img/mou/tuli.jpg";

export default function PartnerMOU() {
    // Static data with arrays for multiple MOU images per partner
    const mouPartners = [
        {
            name: "ANA ARCHITECTS",
            // description: "Strategic partnership for AI development.",
            images: [ana]  
        },
        {
            name: "Center Point Hospital, Medical Sq., Nagpur",
            // description: "Collaboration on local smart city projects.",
            images: [center, center2] // Single image case
        },
        {
            name: "Central India Cardiology Hospital & Research Institute",
            // description: "Joint venture for numerology software.",
            images: [centralindia]
        },
        {
            name: "Cleanearth Sustina AI Pvt. Ltd.", 
            images: [Cleanearth]
        },
        {
            name: "Dr. Anil Golhar, M.S. (SURG) M.S. (Ortho) Spinal, Surgeon, Golhar's Spine, Care & Trauma, Research Institute, Nagpur", 
            images: [dranil, dranil2]
        },
        {
            name: "Eduocean International, Amravati", 
            images: [edu]
        },
        {
            name: "Genesis Hospital & Research Center (Cure Care Trust)", 
            images: [genesis,genesis2]
        },
        {
            name: "Grand Mansion Builder & Developers", 
            images: [grand]
        },
        {
            name: "IGN SOFTWARES Pvt. Ltd.", 
            images: [ign]
        },
        {
            name: "Impact Trade Link", 
            images: [impact]
        },
        {
            name: "Mufaza Investment LLC", 
            images: [mafaza1, mafaza2, mafaza3, mafaza4, mafaza5, mafaza6, mafaza7, mafaza8, mafaza9, mafaza10, mafaza11]
        },
        {
            name: "Sarvakalasha Arts Training LLC", 
            images: [sarvakala, sarvakala2]
        },
        {
            name: "Sora Agro Foodstuff Trading CO.", 
            images: [sora]
        },
        {
            name: "M/s. Trade Ventures, Nagpur", 
            images: [tradeventure]
        },
        {
            name: "M/s. Hotel Tuli International, Sadar, Nagpur", 
            images: [tuli]
        }
    ];

    // State for the Lightbox
    const [lightbox, setLightbox] = useState({ isOpen: false, partnerIndex: 0, imgIndex: 0 });

    const openLightbox = (pIdx, iIdx) => {
        setLightbox({ isOpen: true, partnerIndex: pIdx, imgIndex: iIdx });
    };

    const closeLightbox = () => setLightbox({ ...lightbox, isOpen: false });

    const nextImg = (e) => {
        e.stopPropagation();
        const partner = mouPartners[lightbox.partnerIndex];
        setLightbox({
            ...lightbox,
            imgIndex: (lightbox.imgIndex + 1) % partner.images.length
        });
    };

    const prevImg = (e) => {
        e.stopPropagation();
        const partner = mouPartners[lightbox.partnerIndex];
        setLightbox({
            ...lightbox,
            imgIndex: (lightbox.imgIndex - 1 + partner.images.length) % partner.images.length
        });
    };

    return (
        <section className="py-5 bg-white">
            <div className="container">
                <div className="row mb-5">
                    <div className="col-12 text-center">
                        <h4 className="h33 hover-underline-animation fw-bold mb-2">Our MOU Partners</h4>
                        <p className="text-muted">Official collaborations and signed memorandums</p>
                    </div>
                </div>

                <div className="row">
                    {mouPartners.map((partner, pIdx) => (
                        <div key={pIdx} className="col-lg-3 col-md-6 mb-4">
                            <div className="mou-card shadow-sm border-0 rounded-4 overflow-hidden position-relative">
                                {/* Vertical Rectangle Image Container (2:3 Ratio) */}
                                <div className="mou-img-wrapper position-relative">
                                    <img 
                                        src={partner.images[0]} 
                                        className="img-fluid w-100" 
                                        style={{ aspectRatio: '2/3', objectFit: 'cover' }}
                                        alt={partner.name} 
                                    />
                                    {/* Overlay showing count if > 1 image */}
                                    <div className="mou-overlay d-flex align-items-center justify-content-center" onClick={() => openLightbox(pIdx, 0)}>
                                        <div className="text-white text-center">
                                            <FontAwesomeIcon icon={faExpand} size="2x" className="mb-2" />
                                            <p className="small m-0">View {partner.images.length} Image{partner.images.length > 1 ? 's' : ''}</p>
                                        </div>
                                    </div>
                                    {partner.images.length > 1 && (
                                        <span className="badge bg-primary position-absolute top-0 end-0 m-3">
                                            {partner.images.length} Images
                                        </span>
                                    )}
                                </div>
                                
                                <div className="p-3 bg-white text-center">
                                    <h6 className="fw-bold mb-1 text-truncate">{partner.name}</h6>
                                    <p className="text-muted small mb-0">{partner.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Lighthouse / Lightbox Modal */}
            {lightbox.isOpen && (
                <div className="mou-lightbox-overlay" onClick={closeLightbox}>
                    <button className="btn-close btn-close-white position-absolute top-0 end-0 m-4" aria-label="Close"></button>
                    
                    <div className="lightbox-content d-flex align-items-center justify-content-center">
                        {mouPartners[lightbox.partnerIndex].images.length > 1 && (
                            <button className="nav-btn prev" onClick={prevImg}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                        )}

                        <div className="text-center">
                            <img 
                                src={mouPartners[lightbox.partnerIndex].images[lightbox.imgIndex]} 
                                className="img-fluid rounded shadow-lg" 
                                style={{ maxHeight: '80vh', border: '5px solid white' }}
                                alt="MOU Document"
                            />
                            <div className="text-white mt-3">
                                <h5 className="m-0">{mouPartners[lightbox.partnerIndex].name}</h5>
                                <p className="small">Image {lightbox.imgIndex + 1} of {mouPartners[lightbox.partnerIndex].images.length}</p>
                            </div>
                        </div>

                        {mouPartners[lightbox.partnerIndex].images.length > 1 && (
                            <button className="nav-btn next" onClick={nextImg}>
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        )}
                    </div>
                </div>
            )}

            <style jsx>{`
                .mou-card {
                    transition: transform 0.3s ease;
                    cursor: pointer;
                }
                .mou-card:hover {
                    transform: scale(1.02);
                }
                .mou-img-wrapper {
                    overflow: hidden;
                }
                .mou-overlay {
                    position: absolute;
                    top: 0; left: 0; width: 100%; height: 100%;
                    background: rgba(0, 0, 0, 0.4);
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }
                .mou-card:hover .mou-overlay {
                    opacity: 1;
                }
                /* Lightbox Styles */
                .mou-lightbox-overlay {
                    position: fixed;
                    top: 0; left: 0; width: 100%; height: 100%;
                    background: rgba(0,0,0,0.9);
                    z-index: 1050;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .nav-btn {
                    background: rgba(255,255,255,0.1);
                    border: none;
                    color: white;
                    padding: 15px 20px;
                    border-radius: 50%;
                    margin: 0 20px;
                    transition: background 0.3s;
                }
                .nav-btn:hover {
                    background: rgba(255,255,255,0.3);
                }
                .h33 { color: #222; }
            `}</style>
        </section>
    );
}